import { useState, useEffect, useRef } from "react";
import ReactLoading from "react-loading";

export const RollingTextLoading = ({
  text,
  show,
}: {
  text: String[];
  show: boolean;
}) => {
  const [isFadeOut, setIsFadeOut] = useState(false);
  const rollingTimer = useRef<ReturnType<typeof setInterval> | undefined>(
    undefined
  );
  const fadeTimer = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );
  const textIdx = useRef(0);

  const RollingTime = 6000;
  const FadeTime = 1000;

  useEffect(() => {
    if (show) {
      rollingTimer.current = setInterval(() => {
        setIsFadeOut(true);
        if (textIdx.current >= text.length - 1) {
          setIsFadeOut(false);
          if (rollingTimer.current) clearInterval(rollingTimer.current);
          if (fadeTimer.current) clearTimeout(fadeTimer.current);
          return;
        }
        const newIdx =
          textIdx.current >= text.length - 1 ? 0 : textIdx.current + 1;
        textIdx.current = newIdx;
        fadeTimer.current = setTimeout(() => {
          setIsFadeOut(false);
        }, FadeTime);
      }, RollingTime);
    } else {
      clearAll();
    }

    return () => {
      if (!show) {
        clearAll();
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const clearAll = () => {
    textIdx.current = 0;
    setIsFadeOut(false);
    if (rollingTimer.current) clearInterval(rollingTimer.current);
    if (fadeTimer.current) clearTimeout(fadeTimer.current);
  };

  if (!show) return null;
  return (
    <div className="fixed inset-0">
      <div className="absolute flex flex-col items-center text-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-black bg-opacity-70 rounded-lg p-8 max-w-lg shadow-lg">
        <ReactLoading type="bubbles" color="#fff" width={36} height={36} />
        <div className="text-white mt-3 cursor-default">
          <div className={`relative top-0 opacity-100 transition-all duration-1000 ${isFadeOut ? "top-[-10px] opacity-0" : ""}`}>
            {text[textIdx.current]}
          </div>
        </div>
      </div>
    </div>
  );
};
